// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to handle phone call
  const handleCallClick = (e) => {
    e.preventDefault();
    window.location.href = "tel:+2349020489434";
  };

  // Function to handle smooth scrolling
  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <NavbarContainer>
      <NavbarInner>
        <Logo href="/">ISABELLA</Logo>
        
        {isMobile ? (
          <>
            <MenuButton onClick={toggleMenu}>
              {isMenuOpen ? (
                <CloseIcon>&times;</CloseIcon>
              ) : (
                <HamburgerIcon>
                  <span></span>
                  <span></span>
                  <span></span>
                </HamburgerIcon>
              )}
            </MenuButton>
            
                  {isMenuOpen && (
          <MobileMenu>
            <NavLinks mobile>
              <NavItem>
                <NavLink href="#voice-agent" onClick={(e) => scrollToSection(e, 'voice-agent')}>AI Agent</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#work" onClick={(e) => scrollToSection(e, 'work')}>Work</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#products" onClick={(e) => scrollToSection(e, 'products')}>Products</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#expertise" onClick={(e) => scrollToSection(e, 'expertise')}>Expertise</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#about" onClick={(e) => scrollToSection(e, 'about')}>About</NavLink>
              </NavItem>
              <NavItem>
                <NavLink as={Link} to="/marketing-for-dummies" onClick={() => setIsMenuOpen(false)}>
                  Marketing for Dummies
                </NavLink>
              </NavItem>
            </NavLinks>
            <CallToActionButton 
              onClick={handleCallClick}
              mobile
            >
                          Schedule a Call
                  <CalendarIcon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </CalendarIcon>
                </CallToActionButton>
              </MobileMenu>
            )}
          </>
        ) : (
          <>
            <NavLinks>
            <NavItem>
              <NavLink href="#voice-agent" onClick={(e) => scrollToSection(e, 'voice-agent')}>AI Agent</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#work" onClick={(e) => scrollToSection(e, 'work')}>Work</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#products" onClick={(e) => scrollToSection(e, 'products')}>Products</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#expertise" onClick={(e) => scrollToSection(e, 'expertise')}>Expertise</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#about" onClick={(e) => scrollToSection(e, 'about')}>About</NavLink>
            </NavItem>
            <NavItem>
              <NavLink as={Link} to="/marketing-for-dummies">Marketing for Dummies</NavLink>
            </NavItem>
          </NavLinks>

            <CallToActionButton 
              onClick={handleCallClick}
            >
              Schedule a Call
              <CalendarIcon>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </CalendarIcon>
            </CallToActionButton>
          </>
        )}
      </NavbarInner>
    </NavbarContainer>
  );
};

const NavbarContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: rgba(8, 8, 14, 0.72);
  backdrop-filter: blur(16px) saturate(160%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 1rem 0;
  transition: all 0.3s ease;
`;

const NavbarInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;

const Logo = styled.a`
  font-size: 1.5rem;
  font-weight: 800;
  background: linear-gradient(120deg, #8b5cf6, #ec4899);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-decoration: none;
  letter-spacing: 0.5px;
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2rem;
  
  ${({ mobile }) => mobile && `
    flex-direction: column;
    gap: 1.5rem;
  `}
`;

const NavItem = styled.li``;

const NavLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:hover {
    color: #9370DB; // Purple color on hover
  }
  
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    background: #9370DB;
    left: 0;
    bottom: -4px;
    transition: width 0.3s ease;
  }
  
  &:hover:after {
    width: 100%;
  }
`;

// Changed from Link to button
const CallToActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #8A5CF6;
  color: white;
  text-decoration: none;
  padding: 0.75rem 1.25rem;
  border-radius: 9999px;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(138, 92, 246, 0.3);
  border: none;
  cursor: pointer;
  
  &:hover {
    background: #7546e4;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(138, 92, 246, 0.4);
  }
  
  ${({ mobile }) => mobile && `
    width: fit-content;
    margin-top: 1rem;
  `}
`;

const CalendarIcon = styled.span`
  display: flex;
  align-items: center;
`;

// Mobile menu components
const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  z-index: 1001;
`;

const HamburgerIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  
  span {
    display: block;
    height: 2px;
    width: 100%;
    background-color: white;
    transition: all 0.3s ease;
  }
`;

const CloseIcon = styled.div`
  color: white;
  font-size: 1.75rem;
  line-height: 0.8;
`;

const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(14, 18, 36, 0.98); // Slightly more opaque than navbar
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 2rem;
  animation: fadeIn 0.3s ease;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export default Navbar;